module.exports = __webpack_public_path__ + "static/pyramid-5744df18b5b87dec752e566a31e4b73c.mp4";